export default __webpack_public_path__ + "static/media/image-fallback.d0d49fa0.svg";